<template>
    <div id="register">
        <mu-container>
            <mu-paper class="register_paper" :z-depth="2">
                <mu-row>
                    <mu-col :span="3">
                    </mu-col>
                    <mu-col :span="6">
                        <mu-flex class="right_block" direction="column">
                            <mu-flex align-items="center" justify-content="center" style="width:100%;">
                                <h2>{{ $t('systemInit.title') }}</h2>
                            </mu-flex>
                            <mu-flex direction="column" style="width:100%;">
                                <mu-form ref="registerForm" :model="registerForm" class="register_form"
                                    label-position="right" label-width="80">
                                    <mu-form-item :label="$t('systemInit.name')" prop="companyName"
                                        :rules="$store.state.lang == 'zh' || $store.state.lang == 'zh-CN' ? [$znValidate.require()] : [$enValidate.require()]">
                                        <mu-text-field v-model="registerForm.companyName"></mu-text-field>
                                    </mu-form-item>
                                    <mu-form-item :label="$t('systemInit.contract')" prop="contract"
                                        :rules="$store.state.lang == 'zh' || $store.state.lang == 'zh-CN' ? [$znValidate.require()] : [$enValidate.require()]">
                                        <mu-text-field v-model="registerForm.contract"></mu-text-field>
                                    </mu-form-item>

                                    <mu-form-item :label="$t('systemInit.mobile')" prop="mobile"
                                        :rules="$store.state.lang == 'zh' || $store.state.lang == 'zh-CN' ? [$znValidate.require(), $znValidate.phoneNumber()] : ''">
                                        <mu-text-field v-model="registerForm.mobile" prop="mobile"></mu-text-field>
                                    </mu-form-item>

                                    <mu-form-item :label="$t('systemInit.address')" prop="address"
                                        :rules="$store.state.lang == 'zh' || $store.state.lang == 'zh-CN' ? [$znValidate.require()] : [$enValidate.require()]">
                                        <mu-text-field v-model="registerForm.address" prop="address"></mu-text-field>
                                    </mu-form-item>

                                    <mu-form-item :label="$t('systemInit.accessIP')" prop="accessIP"
                                        :rules="$store.state.lang == 'zh' || $store.state.lang == 'zh-CN' ? [$znValidate.require()] : [$enValidate.require()]">
                                        <mu-text-field v-model="registerForm.accessIP" prop="accessIP"></mu-text-field>
                                    </mu-form-item>

                                    <mu-form-item :label="$t('systemInit.email')" prop="email"
                                        :rules="$store.state.lang == 'zh' || $store.state.lang == 'zh-CN' ? [$znValidate.require(), $znValidate.email()] : [$enValidate.require(), $enValidate.email()]">
                                        <mu-text-field v-model="registerForm.email" prop="email"></mu-text-field>
                                    </mu-form-item>

                                    <mu-form-item :label="$t('systemInit.password')" prop="password"
                                        :rules="$store.state.lang == 'zh' || $store.state.lang == 'zh-CN' ? [$znValidate.require()] : [$enValidate.require()]">
                                        <mu-text-field v-model="registerForm.password" :action-icon="visibility ? 'visibility_off' : 'visibility'" :action-click="() => (visibility = !visibility)" :type="visibility ? 'text' : 'password'" prop="password"></mu-text-field>
                                    </mu-form-item>

                                    <mu-form-item :label="$t('systemInit.confirmPassword')" prop="confirmPassword"
                                        :rules="$store.state.lang == 'zh' || $store.state.lang == 'zh-CN' ? [$znValidate.require(), $znValidate.confirmPassword(registerForm.password)] : [$enValidate.require(), $enValidate.confirmPassword(registerForm.password)]">
                                        <mu-text-field v-model="registerForm.confirmPassword" :action-icon="visibility ? 'visibility_off' : 'visibility'" :action-click="() => (visibility = !visibility)" :type="visibility ? 'text' : 'password'" prop="confirmPassword"></mu-text-field>
                                    </mu-form-item>

                                    <mu-button color="primary" @click="submit" full-width round style="margin-top:24px;"
                                        v-loading="submitLoading">{{ $t('systemInit.submit') }}</mu-button>
                                </mu-form>
                            </mu-flex>
                        </mu-flex>
                    </mu-col>
                </mu-row>
            </mu-paper>
        </mu-container>
    </div>
</template>
<script>
import {initialization} from "../../api/customer/customer"

export default {
    data() {
        return {
            registerForm: {
                companyName: null,
                contact: null,
                mobile: null,
                email: null,
                address: null,
                accessIP: null,
                password: null,
                confirmPassword: null
            },
            submitLoading: false,

            visibility:false,

            addressDisplay: "",
            repeatPasswordRules: [
                { validate: val => !!val, message: this.$t("register.mgs_rule_pass_required") },
                {
                    validate: val => val.length >= 3 && val.length <= 10,
                    message: this.$t("register.mgs_rule_passlength")
                },
                {
                    validate: val => val == this.customerForm.password,
                    message: this.$t("register.msg_rule_secondPass")
                }
            ],
            passwordRules: [
                { validate: val => !!val, message: this.$t("register.mgs_rule_pass_required") },
                {
                    validate: val => val.length >= 3 && val.length <= 10,
                    message: this.$t("register.mgs_rule_passlength")
                },
            ],
        };
    },

    methods: {
        submit() {
            this.$refs.registerForm.validate().then(result => {

                if (!result) {
                    return;
                }

                this.submitLoading = true;
                initialization({...this.registerForm, host:this.registerForm.accessIP})
                .then(res=>{
                    window.open("/", "_self")
                })
                .catch(res=>{
                    this.$toast.error(res.message);
                })
                .finally(res=>{
                    this.submitLoading = false;
                })
            });
        }
    }
};
</script>
<style scoped>
@import "../../assets/css/slideBlock.css";

#register {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}

.register_paper {
    background-color: #ffffff;
    box-shadow: 0 6px 20px 5px rgba(40, 120, 255, 0.1),
        0 16px 24px 2px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    overflow: hidden;
}

.left_block {
    height: 85vh;
    background: #4880ff;
    background: linear-gradient(311deg,
            rgba(115, 109, 255, 1) 0%,
            rgba(169, 127, 255, 1) 100%);
    box-shadow: 0 6px 20px 5px rgba(40, 120, 255, 0.1),
        0 16px 24px 2px rgba(0, 0, 0, 0.05);
    padding: 24px 36px;
}

.left_block .logo img {
    width: 32px;
    height: auto;
    margin-right: 8px;
}

.left_block .logo span {
    font-size: 24px;
    color: #ffffff;
    font-weight: 600;
    font-family: "DINCOND";
}

.right_block {
    height: 85vh;
    padding: 16px 48px;
    overflow: auto;
}

.right_block .register_form {
    width: 100%;
    margin: 48px 0px;
}

.right_block .mail_tip {
    margin-top: 24px;
    width: 100%;
}

.right_block .mail_tip p {
    color: #4e5a63;
    font-weight: 500;
}

.right_block .mail_tip span {
    margin: 8px 0px;
    color: #4e5a63;
    font-size: 12px;
    font-weight: 400;
}

.right_block .success_tip {
    color: #20253a;
    line-height: 28px;
    font-size: 14px;
    text-align: center;
}
</style>
  


// WEBPACK FOOTER //
// src/views/initialization/index.vue